import { differenceInDays, differenceInHours, differenceInMinutes, subDays, subHours } from 'date-fns';

export const getPromoCodeExpiresIn = (expirationDateString: string) => {
  const expirationDate = new Date(expirationDateString);
  const now = new Date();

  const daysLeft = differenceInDays(expirationDate, now);
  const dateWithoutDays = subDays(expirationDate, daysLeft);

  const hoursLeft = differenceInHours(dateWithoutDays, now);
  const dateWithoutDaysHours = subHours(dateWithoutDays, hoursLeft);

  const minutesLeft = differenceInMinutes(dateWithoutDaysHours, now);
  const isTimeUp = daysLeft <= 0 && hoursLeft <= 0 && minutesLeft <= 0;

  return !isTimeUp ? `${daysLeft} д : ${hoursLeft} ч : ${minutesLeft} мин` : '';
};
